module.exports = __webpack_public_path__ + "static/media/ic_fontsize.f7a030b3.svg";